import React from 'react';
import classes from './BannerTopComponent.module.css';
import bannerTopGifMadal from '../../../../../../assets/FinalStage/bannerTopGifMadal.gif';

const BannerTopComponent = ({ colorBackground, title, children }) => {

    return (
        <div className={classes.BannerTopComponent} >
            <div className={classes.bannerTop}>
                <p className={classes.title}>{title}</p>
                <img src={bannerTopGifMadal} alt="" className={classes.bannerTopGif} />
            </div>
            {(colorBackground || children) &&
                <div
                    className={`${classes.bannerBottom} ${colorBackground === 'none' ? classes.bannerBottomTransparent : ''}`}
                    style={colorBackground !== 'none' ? { background: colorBackground } : undefined}
                >
                    {children}
                </div>
            }
        </div>
    );
};

export default BannerTopComponent;
